import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const HTML_TEMPLATE = `
<div>
    <ion-item>
      <ion-label stacked>{{ textLabel }}:</ion-label>
      <thf-icon name="calendar" class="icon" item-end></thf-icon>      
      <ion-datetime class="content" placeholder="" displayFormat="DD/MM/YYYY" [(ngModel)]="value" (ngModelChange)="change()"></ion-datetime>
    </ion-item>
</div>

`;

const CSS_STYLE = `    
label {
  font-family: NunitoSans;
  font-size: 14px;
  font-weight: bold;
  color: #4a5c60;
}

.content {
  font-family: NunitoSans;
  font-size: 14px;
  font-weight: bold;
  color: #0c9abe;
}

.icon {
  font-size: 20px !important;
  color: #0c9abe;
}

`;

/*@Component({
  selector: 'input-date',
  template: HTML_TEMPLATE,
  styles: [CSS_STYLE],
})*/
export class InputDateComponent {

  @Input('formName') formName: string;
  @Input('label') label: string;
  @Input('value') value: string;
  @Input('callbackChange') callbackChange: Function;

  textLabel: string;

  constructor(private _translate: TranslateService) {

  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.textLabel = this._translate.instant(this.label);
    }, 1);

  }

  change() {
    this.callbackChange(this.formName, this.value);
  }

}
